import { lang } from "../config/app.config";
import { httpbase } from "../utils/axios.utils"


export const fetchStaffs = async(branch:string,type:string) => {
  try{
    const staffs = await httpbase().get(`staffs/${branch}/${type}/${type?.includes('?') ? '&' :'?'}lang=${lang}`);
    return staffs.data.data;
  }catch(e){
    console.log(e)
  }
}

export const fetchStaffsByID = async(id:string) => {
  try{
    const staffs = await httpbase().get(`staff-details/${id}/?lang=${lang}`);
    return staffs.data.data;
  }catch(e){
    console.log(e);
    return undefined;
  }
}